import React from 'react';
import { Scale } from 'lucide-react';
import CmsManagedInfoPage from '../components/site/CmsManagedInfoPage';

const TermsOfServiceFallback: React.FC = () => (
  <div className="min-h-screen flex flex-col bg-gray-50 pt-16">
    <main className="flex-grow">
      <section className="bg-gradient-to-br from-blue-600 via-blue-700 to-indigo-800 text-white py-16 md:py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <Scale className="w-16 h-16 mx-auto mb-4" />
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Terms of Service</h1>
            <p className="text-xl text-blue-100">Please read these terms carefully before using our services</p>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 md:p-12">
            <div className="prose prose-lg max-w-none text-gray-600">
              <p className="text-sm text-gray-500 mb-8">Last updated: March 31, 2024</p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">1. Acceptance of Terms</h2>
              <p>
                By accessing or using NLS Store&apos;s website and services, you agree to be bound by these Terms of
                Service. If you do not agree to these terms, please do not use our services.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">2. Account Registration</h2>
              <p>To access certain features, you may need to create an account. You are responsible for:</p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>Providing accurate and complete information</li>
                <li>Maintaining the confidentiality of your account credentials</li>
                <li>All activities that occur under your account</li>
                <li>Notifying us immediately of any unauthorized use</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">3. Products and Pricing</h2>
              <p>All product descriptions and prices are subject to change without notice. We reserve the right to:</p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>Modify or discontinue products without notice</li>
                <li>Limit quantities of any product</li>
                <li>Refuse service to anyone</li>
                <li>Correct pricing errors</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">4. Orders and Payment</h2>
              <p>By placing an order, you represent that:</p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>You are legally capable of entering into binding contracts</li>
                <li>All information you provide is true and accurate</li>
                <li>You are authorized to use the payment method provided</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">5. Shipping and Delivery</h2>
              <p>
                Delivery times are estimates and not guaranteed. Risk of loss and title for items pass to you upon
                delivery to the carrier.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">6. Intellectual Property</h2>
              <p>
                All content on our website, including text, graphics, logos, and images, is our property and protected
                by intellectual property laws.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">7. Limitation of Liability</h2>
              <p>
                To the maximum extent permitted by law, we shall not be liable for any indirect, incidental, special,
                consequential, or punitive damages.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">8. Governing Law</h2>
              <p>
                These terms shall be governed by and construed in accordance with the laws of the State of New York,
                without regard to conflict of law provisions.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">9. Changes to Terms</h2>
              <p>
                We reserve the right to modify these terms at any time. Changes will be effective immediately upon
                posting to the website.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">10. Contact Information</h2>
              <p>For questions about these Terms of Service, please contact us at legal@nlsstore.com.</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
);

const TermsOfService: React.FC = () => (
  <CmsManagedInfoPage route="/terms-of-service" fallback={<TermsOfServiceFallback />} />
);

export default TermsOfService;
